<template>
  <div
    class="question-container"
    :style="{
      border:
        dataObj.status === 1
          ? '1px dashed rgba(58,96,255,1)'
          : '1px solid #EDEFF2',
    }"
  >
    <div class="question-type">图片上传</div>
    <div class="title-view">
      <span style="color: #4c4a56">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span
        >{{ `${index + 1}、` }}
        <span style="color: #4c4a56">
          {{ `${dataObj.caseProblem}` }}
          <span class="limitation">(最多上传{{ pictureNum }}张)</span>
        </span>
      </span>
    </div>
    <div class="question-images">
      <div
        v-for="(item, idx) in images"
        :key="idx"
        style="margin-top: 20px; position: relative"
      >
        <img :src="item" style="width: 100%" />
      </div>
    </div>
    <div
      style="
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        gap: calc((100% - 616px) / 3);
      "
    >
      <div
        class="image-view"
        v-for="(item, idx) in imageList"
        :key="idx"
        @click.stop="showBigImage(item.context)"
      >
        <img
          :src="item.context"
          style="width: 100%; height: 100%; border-radius: 6px"
        />
        <img
          src="@/assets/images/guanbi.png"
          class="delete"
          v-if="!showMask"
          @click.stop="handleDelete(idx)"
        />
        <div class="fangda-box">查看图片</div>
      </div>
      <div
        v-if="imageList.length < pictureNum && !showMask"
        class="image-view"
        @click="handleUpload"
      >
        <div class="plus-icon"></div>
        <span>上传图片</span>
        <span>最大10M</span>
      </div>
    </div>
    <uploadImage
      :show="showUpload"
      :maxCount="pictureNum"
      :images="imageList.length"
      :limitSize="10"
      @upload-close="showUpload = false"
      @upload-success="handleUploadComplete"
      :onImageSelectStart="handleImageSelectStart"
      :onImageSelectEnd="handleImageSelectEnd"
    ></uploadImage>

    <div class="fangda-popup" v-if="fangdaShow" @click="fangdaClose">
      <div class="popup-content" @click.stop>
        <img
          src="@/assets/images/guanbi.png"
          class="popup-guanbi"
          @click="fangdaClose"
        />
        <div class="popup-scroll">
          <div>{{ fangdaTitle }}</div>
          <img :src="fangdaImgUrl" style="width: 100%" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExamPreviewIMAGE",
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    showMask: Boolean,
  },
  data() {
    return {
      index: 0,
      disabled: false,
      showUpload: false,
      pictureNum: 1,
      imageList: [],
      images: [],
      fangdaShow: false,
      fangdaImgUrl: "",
      fangdaTitle: "",
    };
  },
  watch: {
    params: {
      handler(newValue) {
        if (newValue && newValue.data) {
          this.dataObj = newValue.data;
          this.index = newValue.index;
          this.disabled = newValue.data.status !== 4;
          this.pictureNum = newValue.data.pictureNum;
          this.images = JSON.parse(newValue.data.caseProblemImg || "[]");
          const chooseList = JSON.parse(
            newValue.data.chooseList || '{"list":null}',
          );
          this.imageList = chooseList.list === null ? [] : chooseList.list;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleUpload() {
      if (this.dataObj.data.status === 4) {
        this.showUpload = true;
      }
    },
    handleUploadComplete(res) {
      this.imageList = [
        ...this.imageList,
        ...res.map((item) => ({
          id: "",
          context: item,
        })),
      ];

      const updatedData = {
        ...this.dataObj.data,
        chooseList: JSON.stringify({ list: this.imageList }),
      };

      this.$emit(
        "update",
        JSON.stringify({
          data: updatedData,
          index: this.index,
          answer: {
            question_id: this.dataObj.data.id,
            type: this.dataObj.data.type,
            if_hide: this.dataObj.data.if_hide,
            answer: this.imageList,
          },
        }),
      );
      this.showUpload = false;
    },
    handleDelete(index) {
      this.imageList.splice(index, 1);

      const updatedData = {
        ...this.dataObj.data,
        chooseList: JSON.stringify({ list: this.imageList }),
      };

      this.$emit(
        "update",
        JSON.stringify({
          data: updatedData,
          index: this.index,
          answer: {
            question_id: this.dataObj.data.id,
            type: this.dataObj.data.type,
            if_hide: this.dataObj.data.if_hide,
            answer: this.imageList,
          },
        }),
      );
    },
    showBigImage(img) {
      this.fangdaShow = true;
      this.fangdaImgUrl = img;
    },
    fangdaClose() {
      this.fangdaShow = false;
      this.fangdaImgUrl = "";
    },
    handleImageSelectStart() {
      this.$emit("upload");
    },
    handleImageSelectEnd() {
      // Handle image select end
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./exam-preview-common.scss";

.image-view {
  width: 154px;
  height: 154px;
  background: #f4f4f4;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  position: relative;
  cursor: pointer;

  .plus-icon {
    position: relative;
    width: 34px;
    height: 34px;
    margin-top: 30px;
    margin-bottom: 16px;

    &::before,
    &::after {
      content: "";
      position: absolute;
      background-color: #b2b7bf;
    }

    &::before {
      left: 50%;
      top: 0;
      width: 2px;
      height: 100%;
      transform: translateX(-50%);
    }

    &::after {
      top: 50%;
      left: 0;
      width: 100%;
      height: 2px;
      transform: translateY(-50%);
    }
  }

  span {
    font-size: 14px;
    font-weight: 400;
    color: #798497;
  }

  .delete {
    position: absolute;
    width: 25px;
    height: 25px;
    top: 6px;
    right: 6px;
  }
}

.question-images {
  margin-bottom: 10px;
}

.title-view .limitation {
  color: #747474;
}
</style>



// WEBPACK FOOTER //
// src/components/ExamPreview/ExamPreviewIMAGE.vue